import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';


@Injectable({
    providedIn: 'root'
})
export class TokenEncodingService {

    /**
     * Encodes an object into Base64, applies bit shifting, then re-encodes to Base64.
     */
    encode(obj: string): string {
        const base64 = btoa(obj);
        const bytes = new Uint8Array([...base64].map(c => c.charCodeAt(0)));

        // Shift each byte left by 1 bit
        const shifted = bytes.map(b => (b << 1) & 0xFF);

        const shiftedStr = String.fromCharCode(...shifted);
        const finalBase64 = btoa(shiftedStr);

        return finalBase64;
    }

    /**
     * Decodes a Base64 string that was encoded using `encode()`.
     * Reverses bit shifting and restores the original object.
     */
    decode(encoded: string): any {
        try {
            const decodedShifted = atob(encoded);
            const shiftedBytes = new Uint8Array([...decodedShifted].map(c => c.charCodeAt(0)));

            // Reverse shift: shift right by 1 bit
            const originalBytes = shiftedBytes.map(b => (b >> 1) & 0xFF);

            const originalStr = String.fromCharCode(...originalBytes);
            const jsonStr = atob(originalStr);

            return jsonStr;
        } catch (err) {
            console.error('Decode failed:', err);
            return null;
        }
    }
}

@Injectable()
export class CustomTokenStorageService implements AbstractSecurityStorage {
    private readonly storage = sessionStorage;

    constructor(private tokenEncodingService: TokenEncodingService) {
    }

    read(key: string): string | null {
        var value = this.storage.getItem(key);
        if (value != null) {
            return this.tokenEncodingService.decode(value);
        }
        return value;
    }

    write(key: string, value: string): void {
        this.storage.setItem(key, this.tokenEncodingService.encode(value));
    }

    remove(key: string): void {
        this.storage.removeItem(key);
    }

    clear(): void {
        //this.storage.clear();
    }
}

